import { buildUrl } from './utils';

const state = {};
const actions = {
  getLinks({ rootState: { token } }) {
    const url = buildUrl([
      {
        links: ''
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => Promise.resolve(data));
  },
  createLink({ rootState: { token } }, { from, to }) {
    const url = buildUrl([
      {
        links: ''
      }
    ]);
    return this._vm.$http
      .post(url, {
        from,
        to
      })
      .then(({ data }) => Promise.resolve(data));
  },
  updateLink({ rootState: { token } }, { old, update }) {
    const url = buildUrl([
      {
        links: ''
      }
    ]);
    return this._vm.$http
      .put(url, {
        old,
        update
      })
      .then(({ data }) => Promise.resolve(data));
  },
  removeLink({ rootState: { token } }, { from, to }) {
    const url = buildUrl([
      {
        links: ''
      }
    ]);
    return this._vm.$http
      .delete(url, {
        data: {
          from,
          to
        }
      })
      .then(({ data }) => Promise.resolve(data));
  },
  duplicateLinks({ rootState: { token }}, {newNodes, uniqueLinksArray, selectedNodes}) {
    const url = buildUrl([
      {
        links: 'duplicate',
      }
    ]);
    return this._vm.$http
      .post(url, { newNodes, uniqueLinksArray, selectedNodes })
      .then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions
};
